import { httpClient } from '../lib/http-client';

/**
 * Service para gerenciamento de galeria
 */
export class GaleriaService {
  static async getGallery(): Promise<{
    success: boolean;
    data: any[];
    total: number;
  }> {
    return httpClient.get<{ success: boolean; data: any[]; total: number }>('/api/galeria');
  }

  static async getGalleryFile(id: number): Promise<{ success: boolean; data: any }> {
    return httpClient.get<{ success: boolean; data: any }>(`/api/galeria/${id}`);
  }

  static async filterGallery(
    params: any
  ): Promise<{ success: boolean; data: any[]; total: number; filtros: any }> {
    return httpClient.get<{
      success: boolean;
      data: any[];
      total: number;
      filtros: any;
    }>('/api/galeria/filtrar', { params });
  }

  static async downloadGalleryFile(id: number): Promise<Blob> {
    const response = await httpClient.getInstance().get(`/api/galeria/${id}/download`, {
      responseType: 'blob',
    });
    return response.data;
  }

  static async deleteGalleryFile(id: number): Promise<{ success: boolean; message: string }> {
    return httpClient.delete<{ success: boolean; message: string }>(`/api/galeria/${id}`);
  }
}

